// vim: ft=javascript:
export const authClientId = '###OIDC_RP_CLIENT_ID###'
export const authTenantId = 'f7e124e1-3cbb-4714-b90e-d08652874b65'
export const fakeUser = false
